var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [(_vm.hasBreadcrumbs || _vm.pagination) ? _c('div', {
    staticClass: "Polaris-Page__Navigation"
  }, [(_vm.breadcrumbs.length > 0) ? _c('polaris-breadcrumbs', {
    attrs: {
      "breadcrumbs": _vm.breadcrumbs
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pagination) ? _c('div', {
    staticClass: "Polaris-Page__Pagination"
  }, [_c('polaris-pagination', {
    attrs: {
      "plain": "",
      "has-next": _vm.pagination.hasNext,
      "has-previous": _vm.pagination.hasPrevious,
      "next-url": _vm.pagination.nextURL,
      "previous-url": _vm.pagination.previousURL
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.primaryAction) ? [_c('div', {
    staticClass: "Polaris-Page__MainContent"
  }, [_c('div', {
    staticClass: "Polaris-Page__TitleAndActions"
  }, [_c('div', {
    staticClass: "Polaris-Page__Title"
  }, [_c('polaris-display-text', {
    attrs: {
      "size": "large",
      "element": "h1"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.title) + "\n                    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "Polaris-Page__Actions"
  }, [_c('div', {
    staticClass: "Polaris-Page__PrimaryAction"
  }, [_c('polaris-button', {
    attrs: {
      "primary": "",
      "accessibility-label": _vm.primaryAction.accessibiltyLabel,
      "url": _vm.primaryAction.url,
      "external": _vm.primaryAction.external,
      "disabled": _vm.primaryAction.disabled,
      "destructive": _vm.primaryAction.destructive,
      "icon": _vm.primaryAction.icon,
      "loading": _vm.primaryAction.loading
    },
    on: {
      "click": function($event) {
        _vm.handleAction(_vm.primaryAction, true)
      }
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.primaryAction.content) + "\n                        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "Polaris-Page__SecondaryActions"
  }, [(_vm.hasRollup) ? _c('div', {
    staticClass: "Polaris-Page__Rollup"
  }, [_c('polaris-popover', {
    attrs: {
      "active": _vm.rollupOpen
    },
    on: {
      "close": _vm.handleRollupToggle
    }
  }, [_c('template', {
    slot: "activator"
  }, [_c('polaris-button', {
    attrs: {
      "disclosure": ""
    },
    on: {
      "click": _vm.handleRollupToggle
    }
  }, [_vm._v("\n                                        Actions\n                                    ")])], 1), _vm._v(" "), _c('polaris-action-list', {
    attrs: {
      "items": _vm.secondaryActions,
      "sections": _vm.actionGroupsAsListSections
    },
    on: {
      "action-any-item": _vm.handleRollupToggle
    }
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "Polaris-Page__IndividualActions"
  }, [_vm._l((_vm.secondaryActions), function(action) {
    return _c('polaris-page-action', {
      attrs: {
        "accessibility-label": action.accessibiltyLabel,
        "url": action.url,
        "external": action.external,
        "disabled": action.disabled,
        "destructive": action.destructive,
        "icon": action.icon,
        "loading": action.loading
      },
      on: {
        "click": function($event) {
          _vm.handleAction(action, true)
        }
      }
    }, [_vm._v("\n                                    " + _vm._s(action.content) + "\n                            ")])
  }), _vm._v(" "), _vm._l((_vm.actionGroups), function(group) {
    return _c('div', {
      staticClass: "Polaris-Page__ActionGroup"
    }, [_c('polaris-popover', {
      attrs: {
        "active": group.title === _vm.openActionGroup
      },
      on: {
        "close": function($event) {
          _vm.handleActionGroupClose(group)
        }
      }
    }, [_c('template', {
      slot: "activator"
    }, [_c('polaris-page-action', {
      attrs: {
        "disclosure": "",
        "icon": group.icon
      },
      on: {
        "action": function($event) {
          _vm.handleActionGroupOpen(group)
        }
      }
    }, [_vm._v("\n                                            " + _vm._s(group.title) + "\n                                        ")])], 1), _vm._v(" "), _c('polaris-action-list', {
      attrs: {
        "items": group.actions
      },
      on: {
        "action-any-item": function($event) {
          _vm.handleActionGroupClose(group)
        }
      }
    }), _vm._v(" "), (group.details) ? _c('div', {
      staticClass: "Polaris-Page__Details"
    }, [_vm._v("\n                                        " + _vm._s(group.details) + "\n                                    ")]) : _vm._e()], 2)], 1)
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "Polaris-Page__PrimaryAction"
  }, [_c('polaris-button', {
    attrs: {
      "primary": "",
      "accessibility-label": _vm.primaryAction.accessibiltyLabel,
      "url": _vm.primaryAction.url,
      "external": _vm.primaryAction.external,
      "disabled": _vm.primaryAction.disabled,
      "destructive": _vm.primaryAction.destructive,
      "icon": _vm.primaryAction.icon,
      "loading": _vm.primaryAction.loading
    },
    on: {
      "click": function($event) {
        _vm.handleAction(_vm.primaryAction, true)
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.primaryAction.content) + "\n                ")])], 1)])] : _vm._e(), _vm._v(" "), (!_vm.primaryAction) ? [_c('div', {
    staticClass: "Polaris-Page__Title"
  }, [_c('polaris-display-text', {
    attrs: {
      "size": "large",
      "element": "h1"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.title) + "\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "Polaris-Page__Actions"
  }, [_c('div', {
    staticClass: "Polaris-Page__SecondaryActions"
  }, [(_vm.hasRollup) ? _c('div', {
    staticClass: "Polaris-Page__Rollup"
  }, [_c('polaris-popover', {
    attrs: {
      "active": _vm.rollupOpen
    },
    on: {
      "close": _vm.handleRollupToggle
    }
  }, [_c('template', {
    slot: "activator"
  }, [_c('polaris-button', {
    attrs: {
      "disclosure": ""
    },
    on: {
      "click": _vm.handleRollupToggle
    }
  }, [_vm._v("\n                                Actions\n                            ")])], 1), _vm._v(" "), _c('polaris-action-list', {
    attrs: {
      "items": _vm.secondaryActions,
      "sections": _vm.actionGroupsAsListSections
    },
    on: {
      "action-any-item": _vm.handleRollupToggle
    }
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "Polaris-Page__IndividualActions"
  }, [_vm._l((_vm.secondaryActions), function(action) {
    return _c('polaris-page-action', {
      attrs: {
        "accessibility-label": action.accessibiltyLabel,
        "url": action.url,
        "external": action.external,
        "disabled": action.disabled,
        "destructive": action.destructive,
        "icon": action.icon,
        "loading": action.loading
      },
      on: {
        "click": function($event) {
          _vm.handleAction(action, true)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(action.content) + "\n                    ")])
  }), _vm._v(" "), _vm._l((_vm.actionGroups), function(group) {
    return _c('div', {
      staticClass: "Polaris-Page__ActionGroup"
    }, [_c('polaris-popover', {
      attrs: {
        "active": group.title === _vm.openActionGroup
      },
      on: {
        "close": function($event) {
          _vm.handleActionGroupClose(group)
        }
      }
    }, [_c('template', {
      slot: "activator"
    }, [_c('polaris-page-action', {
      attrs: {
        "disclosure": "",
        "icon": group.icon
      },
      on: {
        "action": function($event) {
          _vm.handleActionGroupOpen(group)
        }
      }
    }, [_vm._v("\n                                    " + _vm._s(group.title) + "\n                                ")])], 1), _vm._v(" "), _c('polaris-action-list', {
      attrs: {
        "items": group.actions
      },
      on: {
        "action-any-item": function($event) {
          _vm.handleActionGroupClose(group)
        }
      }
    }), _vm._v(" "), (group.details) ? _c('div', {
      staticClass: "Polaris-Page__Details"
    }, [_vm._v("\n                                " + _vm._s(group.details) + "\n                            ")]) : _vm._e()], 2)], 1)
  })], 2)])])] : _vm._e()], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b28d73ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b28d73ca","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisPageHeader.vue
// module id = 213
// module chunks = 0